import React from 'react';
import {RibbonContainer, LeftCornerRibbon} from 'react-ribbons';

class Ribbon extends React.Component {

    handleType(type){
        switch (type) {
            case 'success':
                return {backgroundColor: '#8CC152', color: 'white'};
            case 'info':
                return {backgroundColor: '#4A89DC', color: 'white'};
            case 'warning':
                return {backgroundColor: '#E0C341', color: 'black'};
            case 'danger':
                return {backgroundColor: '#DA4453', color: 'white'};
            default:
                return {backgroundColor: '#e0e0e0', color: 'black'};
        }
    };

    render() {
        const {title, children, type} = this.props;

        const propsType = this.handleType(type);

        return (
            <RibbonContainer className="custom-class">
                <LeftCornerRibbon {...propsType} fontFamily="Vazir">
                    {title}
                </LeftCornerRibbon>
                {children}
            </RibbonContainer>
        );
    }
}

export default Ribbon;
